import 'semantic-ui-css/semantic.min.css'
import '@tolk-ai/ui-library-react/dist/ui-library-react.esm.css'

import App from './views/layouts/App'
import app from './modules/app'
import './index.css'

app.bootstrap('root')(App)
